module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "reload": function($event) {
        return _vm.fetch(true)
      }
    }
  }), _vm._v(" "), (!_vm.activeOrders.length && !_vm.upcomingOrders.length && !_vm.loading) ? _c('div', {
    staticClass: "no-orders"
  }, [_c('p', [_vm._v("Hittade inga planerade resor.")])]) : _vm._e(), _vm._v(" "), (_vm.activeOrders.length) ? _c('div', {
    staticClass: "booking-group"
  }, _vm._l((_vm.activeOrders), function(order) {
    return _c('PrettyOrder', {
      key: 'a' + order.resvid,
      attrs: {
        "order": order,
        "bookMoreCallback": _vm.bookMore
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.upcomingOrders.length) ? _c('div', {
    staticClass: "booking-group"
  }, _vm._l((_vm.upcomingOrders), function(order) {
    return _c('PrettyOrder', {
      key: 'u' + order.resvid,
      attrs: {
        "order": order,
        "bookMoreCallback": _vm.bookMore
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b91c34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyPageJourney.vue
// module id = 918
// module chunks = 0